<template>
  <div class="payment-page">
  <div class=" height-s-fix">
    <div class="container-fluid">
      <div class="row mx-0">
        <div class="col-md-12">
          <div class="brand-logo-mob text-left">
            <img src="/img/icons/radiate-logo.png" width="100px" height="100px" alt="" class="img-fluid">
          </div>
        </div>
      </div>
    </div>
    <div class="card-info">
      <div class="info-wrapper">
        <div class="row No-padding">
          <div class="col-9 goel-card">
            <p>EOI Booking</p>
            <h2 class="page-heading">Signature Towers </h2>
            <p class="align-data">Juinagar, Navi Mumbai</p>
          </div>
        <div class="col-3">
          <div class="text-right">
            <img src="/img/icons/pp-logo-2.png" height="100px" width="100px" alt="" class="img-fluid">
          </div>
        </div>
        <div class="col-12 px-0 paymnet-details">
          <div class="paymnet-details-title">Pay EOI</div>
          <div class="plan-body">
            <div class="payment-section">
              <span class="payment-title">Selected Variant </span>
              <span class="payment-value">{{selectedFloor.configuration}} - {{selectedFloor.area}} sqft</span>
            </div>
            <div class="payment-section">
              <span class="payment-title">Building </span>
              <span class="payment-value">{{selectedTypology.key}}</span>
            </div>
            
          </div>
        </div>
        <div class="col-12 payment-button-section px-0 mt-4 mob-hide">
          <div class="col-8 px-0 ">
            <input type="text" class="payment-amount" name="payment-amount" readonly :value="totalAmount"/>
          </div>
          <div class="col-4 px-0">
            <button type="button" @click="onSubmit" class="btn btn-block payment-btn">Pay EOI</button>
          </div>
        </div>
        <div class="col-12 payment-button-section mob-show">
          <label class="payment-amount-label">EOI Amount</label>
           <input type="text" class="payment-amount" name="payment-amount" readonly :value="totalAmount"/>
            <button type="button" @click="onSubmit" class="btn btn-block payment-btn">Pay EOI</button>
        </div>
        <div class="row back-section">
          <button @click="$router.push({name:'Unit', query:{...$route.query}})" type="button" class="prevButton">
            <img src="@/assets/images/back-arrow.svg" alt="">
                Back</button>
        </div>
      </div>
    </div>
  </div>
  <ProgressBar :steps="formSteps" :activeStepNo="4"/>
  <div class="col-12 powered-by powered-by-mob">Powered by <span class="powered-by-ppistol ml-1"> PropertyPistol&nbsp;Technologies</span></div>
  </div>
</div>
</template>

<script>
import {FormSteps} from '@/assets/scripts/utility.js';
import ProgressBar from "@/components/ProgressBar.vue";
export default {
  components: {
    ProgressBar
  },
  data() {
    return {
      formSteps:FormSteps,
    }
  },
  mounted(){
    this.$store.dispatch('setLoading',false);
  },
    methods: {
      onSubmit() {
        const urlParams = new URLSearchParams({
          typology:this.selectedTypology.uuid,
          configuration:this.selectedFloor.uuid,
          ...(this.userId ?{userId: atob(this.userId)}:{}),
          planId:this.planId

        });
        window.open(`${this.$axios.defaults.baseURL}bookings/new?${urlParams}`,'_self');
      }
    },
  computed: {
    selectedFloor() {
      return this.$store.getters.selectedFloor;
    },
    selectedTypology() {
      return this.$store.getters.selectedTypology;
    },
    selectedWing(){
      return this.$store.getters.selectedWing;
    },
    amount(){
      return this.$store.getters.amount;
    },
    userId(){
      return this.$store.getters.userId
    },
    planId(){
      return this.$store.getters.planId
    },
    totalAmount(){
      return `₹ ${Number(this.amount).toLocaleString('en-IN')}`
    }
  }
}
</script>

<style scoped>
  .payment-page{
    background: #ffffff;
  }
.back-section{
  padding-left: 30px;
}
.powered-by-mob{
  display: none;
}
.powered-by {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  /* position: absolute;
  bottom: 25px; */
  left: 50%;
  transform: translateX(-50%);
  color: #00000080;
  margin: 40px auto 0;
  padding-bottom: 40px;
}
.powered-by .powered-by-ppistol{
  color: #000000;
}

.prevButton {
  color: #494899;
  border: none;
  background: transparent;
  font-weight: 600;
  font-size: 16px;
  margin-top: 30px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: 0.3s;
}

.prevButton:hover{
  gap: 10px;
}

.paymnet-details{
  background: #FFFFFF;
  border: 1px solid rgba(73, 72, 153, 0.2);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  margin-top: 40px;
}
.paymnet-details-title{
  padding:16px;
  background: #4948991A;
  border-radius: 10px 10px 0px 0px;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
}

.payment-section{
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 16px;
}

.payment-section:not(:last-child){
  border-bottom: 1px solid #DBDAEB;
}

.payment-section{
  font-size: 13px;
  line-height: 16px;
  color: #00000080;
}

.payment-button-section{
  display: flex;
}
.payment-title{
  display: block;
  margin-bottom: 6px;
}

.payment-value{
  color: #000000;
}

.payment-amount{
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  padding-left: 16px;
  background: #4948991A;
  width: 100%;
  border: none;
  padding-top: 15px;
  padding-bottom: 14px;
  color: #00000080;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.payment-btn{
  background: #494899;
  border-radius: 0px 4px 4px 0px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  width: 100%;
  box-shadow: none;
  height: 100%;
}

.payment-btn:focus, .payment-btn.focus{
  box-shadow: none;
}
.payment-btn:hover, .payment-btn:active{
  color: #ffffff;
}
/* .container {
  background: #FFFFFF;
} */
.card-info {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  margin: 50px;
  padding: 50px;
  margin: 0 auto; /* Added */
  float: none; /* Added */
  margin-bottom: 10px; /* Added */
}
.info-section-details {
    /* position: absolute; */
width: 100%;
display: flex;
align-items: center;
/* height: 83px; */
margin: 2px;
border: 1px solid rgba(73, 72, 153, 0.2);
box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
margin: 0px;
padding: 20px;
background: #494899;
opacity: 0.1;
border-radius: 10px 10px 0px 0px;

}
  .info-wrapper {
    /* background: #fff; */
    width: 100%;
    /* padding: 16px; */
    /* border-radius: 8px; */
    display: flex;
  }

  .info-wrapper h2,
  .amenities-section h2 {
    font-size: 12px;
    font-weight: bold;
    color: #000;
    margin-bottom: 10px;
  }
     .info-wrapper .page-heading {
    font-size: 12px;
    font-weight: bold;
    color: #000;
    font-weight: 700;
    font-size: 24px;
  }

  .info-wrapper p {
    font-size: 13px;
    color: #000000;
    line-height: 18px;
    padding: 16px;
    text-transform: uppercase;
    opacity: 0.5;
    padding-left: 0px;
    padding-bottom: 0px;
  }
.info-wrapper .align-data {
    font-size: 13px;
    color: #000000;
    line-height: 18px;
    text-transform: none;
    opacity: 0.5;
    padding-left: 0px;
    padding-top: 0;
    margin-bottom: 0;
 }
 .mob-show{
  display: none;
 }

 @media (min-width:992px){
  .card-info{
    width: 35%;
  }
 }

 @media (max-width:991px){
  .mob-show{
    display: block;
  }
  .prevButton{
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;
  }
  .card-info{
    padding: 0;
  }
  .back-section{
    width: 100%;
    background: #f6f6f6;
   }
  .info-wrapper .row{
    padding-left: 0;
    padding-right: 0;
    margin-left: 0;
    margin-right: 0;
  }
  .goel-card{
    padding-left: 20px;
    padding-right: 16px;
  }
  .paymnet-details{
    border-radius: 0;
  }
  .paymnet-details-title{
    border-radius: 0;
  }
  .mob-hide{
    display: none;
  }
  .payment-button-section{
    padding-top: 20px;
    padding-left: 0;
    padding-right: 0;
  }

  .payment-button-section label{
    padding-left: 16px;
  }
  .payment-btn{
    height: unset;
    width: unset;
    padding: 16px 50px;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    border-radius: 4px;
  }

  .powered-by.powered-by-mob{
    display: block;
    position: static;
    margin: auto;
    text-align: center;
    transform: none;
    padding-top: 50px;
    background: #f6f6f6;
    padding-bottom: 50px;
  }

 }
</style>